    export function initHeader(){
       setTimeout(function (){
           const mainWrapper = document.querySelector(
               'body[data-simplebar] > .simplebar-wrapper > .simplebar-mask > .simplebar-offset > .simplebar-content-wrapper'
           ) as HTMLElement;
           if (mainWrapper) {
               mainWrapper.addEventListener('scroll', () => {
                   const scrollTop = mainWrapper.scrollTop;

                   if (scrollTop > 20) {
                       document.body.classList.add('header-fixed');
                   } else {
                       document.body.classList.remove('header-fixed');
                   }
               });
           }
       }, 500)

        const hamburger = document.querySelector<HTMLElement>(".hamburger");

        if (hamburger) {
            hamburger.addEventListener("click", () => {
                document.body.classList.toggle("menu-active");
                if(document.body.classList.contains("service-one-active")){
                    document.body.classList.remove("service-one-active")
                }
                if(document.querySelector('.services-menus-block.visited')){
                    document.querySelector('.services-menus-block.visited').classList.remove('visited')
                }
            });
        }

        const menuItem = document.querySelector<HTMLElement>('.header-menu__item-service');
        const servicesMain = document.querySelector<HTMLElement>('.services-main');

        function isDesktop(): boolean {
            return window.innerWidth > 1140;
        }

    // Наведение на пункт "Услуги"
        menuItem?.addEventListener('mouseenter', () => {
            if (isDesktop()) {
                document.body.classList.add('service-menu-active');
            }
        });

    // Убираем класс при клике вне .services-main и самого пункта меню
        document.addEventListener('click', (event: MouseEvent) => {
            if (!isDesktop()) return;

            const target = event.target as Node;

            const clickedInsideMenu = menuItem?.contains(target);
            const clickedInsideServices = servicesMain?.contains(target);

            if (!clickedInsideMenu && !clickedInsideServices) {
                document.body.classList.remove('service-menu-active');
            }
        });

        const menuItems = document.querySelectorAll<HTMLElement>(".services-header-menu-item");
        const menuBlocks = document.querySelectorAll<HTMLElement>(".services-menus-block");

        if (menuItems.length && menuBlocks.length) {
            menuItems.forEach((item) => {
                item.addEventListener("mouseenter", () => {
                    if (window.innerWidth > 1140) {
                        const menuId = item.dataset.menuId;

                        // Снимаем active со всех пунктов меню
                        menuItems.forEach((el) => el.classList.remove("active"));
                        // Активируем текущий
                        item.classList.add("active");

                        // Снимаем active со всех блоков
                        menuBlocks.forEach((block) => block.classList.remove("active"));
                        // Ищем блок с совпадающим data-menu-content
                        const targetBlock = document.querySelector<HTMLElement>(
                            `.services-menus-block[data-menu-content="${menuId}"]`
                        );
                        if (targetBlock) {
                            targetBlock.classList.add("active");
                        }
                    }
                });
            });
        }

        const serviceLink = document.querySelector<HTMLAnchorElement>(
            ".header-menu__item-service .header-menu__link-service"
        );
        const backButton = document.querySelector<HTMLButtonElement>(".services-main .back-menu");

        if (serviceLink) {
            serviceLink.addEventListener("click", (e) => {
                if (window.innerWidth <= 1140) {
                    e.preventDefault(); // блокируем переход по ссылке
                    document.body.classList.add("service-one-active");
                }
            });
        }

        if (backButton) {
            backButton.addEventListener("click", () => {
                if (window.innerWidth <= 1140) {
                    document.body.classList.remove("service-one-active");
                }
            });
        }

        const menuItemsMobile = document.querySelectorAll<HTMLElement>(
            ".services-header-menu-item"
        );

        menuItemsMobile.forEach((item) => {
            const buttonIcon = item.querySelector<HTMLElement>(".button-icon");
            buttonIcon?.addEventListener("click", (e) => {
                if (window.innerWidth <= 1140) {
                    e.preventDefault();
                    const menuId = item.dataset.menuId;
                    if (!menuId) return;

                    const targetBlock = document.querySelector<HTMLElement>(
                        `.services-menus-block[data-menu-content="${menuId}"]`
                    );
                    if (targetBlock) {
                        targetBlock.classList.add("visited");

                        // Назад внутри этого блока
                        const backBtn = targetBlock.querySelector<HTMLButtonElement>(".back-menu");
                        backBtn?.addEventListener("click", () => {
                            targetBlock.classList.remove("visited");
                        });
                    }
                }
            });
        });

        function headerCatalogSearch(){
            const searchInput = document.querySelector<HTMLInputElement>('.search-header');
            const categoryItems = document.querySelectorAll<HTMLLIElement>('.services-header-menu-item');
            const menuBlocks = document.querySelectorAll<HTMLElement>('.services-menus-block');

            if (searchInput) {
                searchInput.addEventListener('input', () => {
                    const query = searchInput.value.toLowerCase();

                    menuBlocks.forEach((block) => {
                        const links = block.querySelectorAll<HTMLElement>('.services-link');
                        let anyVisible = false;

                        links.forEach(link => {
                            if (link.textContent?.toLowerCase().includes(query)) {
                                (link.closest('.services-item') as HTMLElement).style.display = '';
                                anyVisible = true;
                            } else {
                                (link.closest('.services-item') as HTMLElement).style.display = 'none';
                            }
                        });

                        // Скрываем/показываем блок меню
                        block.style.display = anyVisible ? '' : 'none';

                        // Находим соответствующую категорию
                        const menuId = block.dataset.menuContent;
                        if (menuId) {
                            const category = document.querySelector<HTMLLIElement>(`.services-header-menu-item[data-menu-id="${menuId}"]`);
                            if (category) {
                                category.style.display = anyVisible ? '' : 'none';
                            }
                        }
                    });
                });
            }

        }
        headerCatalogSearch();
        const langBlocks: NodeListOf<HTMLElement> = document.querySelectorAll(".header-lang");

        langBlocks.forEach((lang) => {
            const toggleBtn = lang.querySelector<HTMLButtonElement>(".header-lang__default");
            const items = lang.querySelectorAll<HTMLAnchorElement>(".header-lang__item");

            if (!toggleBtn) return;

            // Клик по кнопке
            toggleBtn.addEventListener("click", (e: MouseEvent) => {
                e.stopPropagation();
                lang.classList.toggle("active");
            });

            // Клик по пунктам списка
            items.forEach((item) => {
                item.addEventListener("click", () => {
                    lang.classList.remove("active");
                });
            });

            // Клик вне блока
            document.addEventListener("click", (e: MouseEvent) => {
                if (!lang.contains(e.target as Node)) {
                    lang.classList.remove("active");
                }
            });
        });
    }